<a *ngIf="file.content" [href]="getFileUrl(file.content['path'])" class="btn_cta " [ngClass]="(file.content.template) ? file.content.template.class : ''" download="{{ file.content['originalName'] }}" target="_blank">
    <span *ngIf="file.content.name">
        {{ file.content.originalName }}
    </span>
    <span *ngIf="!file.content.name">
        {{ file.content.name }}
    </span>
</a>
